import {
  UPDATE_PARTNER_HOST_FAILED,
  UPDATE_PARTNER_HOST_SUCCESS,
  UPDATE_PARTNER_HOST_LOADING,
} from "../types";

const initialState = {
  update_loading: false,
  update_data: null,
  update_error: null,
};

export const updatePartnerHostReducer = (
  state = initialState,
  action: { type: any; loading?: any; payload?: any; error?: any }
) => {
  switch (action.type) {
    case UPDATE_PARTNER_HOST_LOADING:
      return {
        ...state,
        update_loading: action.loading,
        update_error: null,
      };
    case UPDATE_PARTNER_HOST_SUCCESS:
      return {
        ...state,
        update_loading: false,
        update_data: action.payload,
        update_error: null,
      };
    case UPDATE_PARTNER_HOST_FAILED:
      return {
        ...state,
        update_loading: false,
        update_data: null,
        update_error: action.error,
      };
    default:
      return state;
  }
};
